import request from "./request";
// 获取电脑端签名
export function getSign(params) {
  return request({
    url: "/app-api/print/computer/getSign",
    method: "get",
    params,
  });
}

// 获取微信小程序码-电脑端使用
export function wxaqrcode(data) {
  return request({
    url: "/app-api/member/social-user/wxa-qrcode",
    method: "post",
    data,
  });
}
// 获取电脑上传文件列表---电脑端使用
export function getComputerFilesList(params) {
  return request({
    url: "/app-api/print/computer/getComputerFilesList",
    method: "get",
    params,
  });
}

export function getUploadPostPolicy(params) {
  return request({
    url: "/app-api/print/computer/upload-file/post-policy",
    method: "get",
    params,
  });
}

export function computerupload(data) {
  return request({
    url: "/app-api/print/computer/add/computer-upload",
    method: "POST",
    data,
  });
}

export function computerdelete(webToken, id) {
  return request({
    url: `/app-api/print/computer/delete?webToken=${webToken}&id=${id}`,
    method: "DELETE",
  });
}
